import { loadCookieYes } from '../helpers/publicCookieConsent'

loadCookieYes()
